import { render } from "./hotel-banner.vue?vue&type=template&id=d2feca70&scoped=true"
import script from "./hotel-banner.vue?vue&type=script&lang=js"
export * from "./hotel-banner.vue?vue&type=script&lang=js"

import "./hotel-banner.vue?vue&type=style&index=0&id=d2feca70&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-d2feca70"

export default script